import { ids } from "@icarros/theme-react";
import styled from "styled-components";
const { size } = ids || {};
const StyledButton = styled.button `
  height: ${size.general.ids_size_general_48x};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${size.general.ids_size_general_8x}
    ${size.general.ids_size_general_16x};
  border: 0 none;
  background: none;
  cursor: pointer;
`;
export default StyledButton;
//# sourceMappingURL=IconButton.style.js.map